export function MLMCore() {
   return '/ifacare-core/v1'
}
export function MLMAdmin() {
   return '/ifacare-admin/v1'
}
export function MLMReport() {
   return '/ifacare-report/v1'
}




// WEBPACK FOOTER //
// ./src/utils/requestApi.js